import { Phone } from "lucide-react";
import { BUSINESS } from "@/lib/constants";

export const TopBar = () => (
  <div data-testid="top-trust-bar" className="bg-[#08080A] text-white">
    <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-2 sm:px-6 lg:px-8">
      <p className="text-[11px] font-medium tracking-[0.18em] text-[#C6C0B4] sm:text-xs" data-testid="top-bar-tagline">
        {BUSINESS.descriptor}
      </p>
      <a
        href={BUSINESS.phoneHref}
        data-testid="top-bar-phone-link"
        className="flex items-center gap-1.5 text-[11px] font-semibold tracking-wide text-white transition-colors duration-200 hover:text-[#D8B54A] sm:text-xs"
      >
        <Phone className="h-3 w-3" strokeWidth={2} />
        Call {BUSINESS.phone}
      </a>
    </div>
  </div>
);
